/* eslint-disable radix */
import { Color, Vector2 } from 'three';

import { DEBUG } from '@/scripts/stage/constants';
import emitter from '@/scripts/stage/globals/emitter';
import Scene from '@/scripts/stage/globals/scene';
import gui from '@/scripts/stage/globals/gui';


const opts = {
  fogColor: '#eaf2f5',
  objColor: '#ffffff',
  hemi_ground: '#dbdbdb',
  hemi_color_1: '#96d3e1',
  hemi_color_2: '#f7d9aa',
  hemi_color_3: '#e096c3',
};

class Shared {
  constructor() {
    this.opts = opts;

    this.fogColor = {

      value: new Color(parseInt(opts.fogColor.replace('#', '0x'))),
    };

    this.objColor = {

      value: new Color(parseInt(opts.objColor.replace('#', '0x'))),
    };

    this.hemi_ground = {

      value: new Color(parseInt(opts.hemi_ground.replace('#', '0x'))),
    };

    this.hemi_color_1 = {

      value: new Color(parseInt(opts.hemi_color_1.replace('#', '0x'))),
    };

    this.hemi_color_2 = {

      value: new Color(parseInt(opts.hemi_color_2.replace('#', '0x'))),
    };

    this.hemi_color_3 = {

      value: new Color(parseInt(opts.hemi_color_3.replace('#', '0x'))),
    };

    this.screensize = {

      value: new Vector2(1, 1),
    };

    this.aspect = {

      value: 0,
    };


    Scene.background = this.fogColor.value;

    emitter.on('resize', this.resize.bind(this));

    if (DEBUG) {
      gui.addColor(opts, 'fogColor').onChange((e) => {
        this.fogColor.value.setHex(parseInt(e.replace('#', '0x')));
      }).listen();

      gui.addColor(opts, 'objColor').onChange((e) => {
        this.objColor.value.setHex(parseInt(e.replace('#', '0x')));
      }).listen();

      gui.addColor(opts, 'hemi_ground').onChange((e) => {
        this.hemi_ground.value.setHex(parseInt(e.replace('#', '0x')));
      }).listen();

      gui.addColor(opts, 'hemi_color_1').onChange((e) => {
        this.hemi_color_1.value.setHex(parseInt(e.replace('#', '0x')));
      }).listen();

      gui.addColor(opts, 'hemi_color_2').onChange((e) => {
        this.hemi_color_2.value.setHex(parseInt(e.replace('#', '0x')));
      }).listen();

      gui.addColor(opts, 'hemi_color_3').onChange((e) => {
        this.hemi_color_3.value.setHex(parseInt(e.replace('#', '0x')));
      }).listen();
    }
  }

  resize(w, h) {
    this.screensize.value.x = w;

    this.screensize.value.y = h;

    this.aspect.value = w / h;
  }
}

export default new Shared();
